import documentReady from "./../helpers/document-ready";
const modalsWithUrlParam = { "tos-modal": "tos", "privacy-modal": "privacy", "gdpr-modal": "gdpr" };

const modal = (divId) => {
    return {
        activate: () => {
            const element = document.getElementById(divId);
            element.setAttribute("aria-hidden", "false");
            element.classList.add("is-active");
            document.body.classList.add("no-scroll");

            window.addEventListener("click", windowClickListener);
        },
        deactivate: () => {
            const element = document.getElementById(divId);
            element.setAttribute("aria-hidden", "true");
            element.classList.remove("is-active");
            document.body.classList.remove("no-scroll");

            // Polyfill used for IE here.. https://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
            document.dispatchEvent(new window.CustomEvent("modalEscape"));
        },
        toggle: () => {
            const element = document.getElementById(divId);
            if (!element.classList.contains("is-active")) {
                window.addEventListener("click", windowClickListener);
            }
            element.classList.toggle("is-active");
            const closeButton = document.querySelector(".c-modal__close");
            if (closeButton) {
                closeButton.addEventListener("click", () => deactivateModals());
            }

            if (element.attributes["aria-hidden"].value === "true") {
                element.setAttribute("aria-hidden", "false");
                return document.body.classList.add("no-scroll");
            }
            element.setAttribute("aria-hidden", "true");

            return document.body.classList.remove("no-scroll");
        },
    };
};

const windowClickListener = (event) => {
    if (!event.target.classList.contains("c-modal")) return;

    deactivateModals();
};

const loadListeners = () =>
    documentReady(() => {
        const closeButtons = document.querySelectorAll(".c-modal__close");
        closeButtons.forEach((closeButton) => {
            closeButton.addEventListener("click", () => deactivateModals());
        });

        const modalButtons = document.querySelectorAll("[data-modal]");

        modalButtons.forEach((modalButton) => {
            modalButton.addEventListener("click", (event) => {
                const modelId = event.target.getAttribute("data-modal");
                modal(modelId).toggle();
                if (modalsWithUrlParam[modelId]) {
                    window.history.replaceState(null, null, `?${modalsWithUrlParam[modelId]}`);
                }
            });
        });

        // Disables any modal that is active
        document.onkeydown = (evt) => {
            evt = evt || window.event;
            let isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key == "Escape" || evt.key == "Esc";
            } else {
                isEscape = evt.keyCode == 27;
            }
            if (isEscape) {
                deactivateModals();
            }
        };
    });

const deactivateModals = () => {
    window.history.replaceState(null, null, window.location.pathname);
    const modals = document.getElementsByClassName("c-modal");
    Array.from(modals).forEach((element) => {
        if (element.classList.contains("is-active")) {
            modal(element.id).deactivate();
        }
        if (element.dataset.modalType === "video") {
            // pause video when closing modal
            document.querySelector(`#${element.id} video`).pause();
        }
    });

    window.removeEventListener("click", windowClickListener);
};

const openModalsWithUrlParam = () => {
    documentReady(() => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        Object.values(modalsWithUrlParam).forEach((i, index) => {
            if (urlParams.has(i)) {
                modal(Object.keys(modalsWithUrlParam)[index]).toggle();
            }
        });
    });
};

export { loadListeners, openModalsWithUrlParam };

export default modal;
